import { render, staticRenderFns } from "./IngredientStockView.vue?vue&type=template&id=42528978&scoped=true"
import script from "./IngredientStockView.vue?vue&type=script&lang=js"
export * from "./IngredientStockView.vue?vue&type=script&lang=js"
import style0 from "./IngredientStockView.vue?vue&type=style&index=0&id=42528978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42528978",
  null
  
)

export default component.exports